import { css, SimpleInterpolation } from "styled-components";

export const getScrollbarStyle: (option?: {
  backgroundColor?: string;
  width?: string;
  height?: string;
}) => SimpleInterpolation = (option) => {
  const defaultOption = {
    backgroundColor: "transparent",
    width: "6px",
    height: "6px",
  };
  const { backgroundColor, width, height } = { ...defaultOption, ...option };
  return css`
    ::-webkit-scrollbar {
      width: ${width};
      height: ${height};
    }
    ::-webkit-scrollbar-corner {
      background-color: ${backgroundColor};
    }
    ::-webkit-scrollbar-track {
      border-radius: 4px;
      background-color: ${backgroundColor};
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: #636363;
    }
    scrollbar-width: thin;
    scrollbar-color: #636363 ${backgroundColor};
  `;
};
